import { useTranslation } from 'react-i18next';
import { Target } from '@phosphor-icons/react';

import { GoalEditor } from '@/components/coach/GoalEditor';

// CoachGoalsCard — the onboarding "what matters this season?" goals card
// (docs/ai-club-coach-plan.md §3). It's the always-open, full-header version
// shown during setup, when the club is picking its goals for the first time.
// After onboarding, goal editing lives inside the coach dashboard's goal
// section (revealed by its edit button) rather than as a standing card — see
// CoachDashboard. Both share the same GoalEditor body. Org-admin only — the
// endpoint enforces it; a non-admin never sees this card.
export function CoachGoalsCard({ slug }: { slug: string }) {
  const { t } = useTranslation('common');
  return (
    <section className="flex w-full flex-col gap-4 rounded-2xl border border-border bg-background p-5 md:p-6">
      <header className="flex items-start gap-3">
        <span className="mt-0.5 text-foreground/70">
          <Target size={24} weight="bold" aria-hidden />
        </span>
        <div className="flex flex-col gap-1">
          <h2 className="font-heading text-lg font-bold tracking-tight">
            {t('coach.goals.wizard.title')}
          </h2>
          <p className="max-w-xl text-sm text-muted-foreground">
            {t('coach.goals.wizard.subtitle')}
          </p>
        </div>
      </header>

      <GoalEditor slug={slug} />
    </section>
  );
}
